module.exports = {
	/**
	 * The (very) approximated number of adserver report-rows per adUnit/hour shouldn't be above this number,
	 * in order to prevent various reporting problems (both in adserver and HBA) */
	MAX_COMBOS_PER_REPORT_UNIT: 1000,

	/** Which report (in reversed order) to start adding custom dimensions as default (0 means last report) */
	CUSTOM_DIM_START_GROUP: 1,

	/** Custom dimensions that we, for various reasons, don't want to synchronize from adserver */
	FORBIDDEN_GRANULAR_CUSTOM_DIMS: [
		'Browser name', // We're already using the "Browser" dimension from the adserver, so no need to add this.
		'Browser version', // New values will appear too often, and we're not updating supported values automatically.
		'Hostname', // TODO: We should add the adservers "Domain" dimention as a built-in dimension instead.
		'Platform', // TODO: We should add the adservers "Device category" dimention as a built-in dimension instead.
		'Operating system', // TODO: We should add the adservers "OS" dimention as a built-in dimension instead.
		'Prebid.js version', // New values will appear too often, and we're not updating supported values automatically.
	],
};
